import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import {
  Nav,
} from './layout';
import {
  RouteUsers,
  RoutePics,
  RouteHorses,
  RouteBanners,
  RoutePlayers,
  RouteLocations,
  RouteRaces,
  RouteBadges,
  RouteTrades,
  RouteBreeds,
  RouteShares,
  RouteTrainings,
  RouteConfigs,
  RouteItems,
  RouteBlockchainTransactions,
  RoutePaymentRecords,
  RouteOperations,
  RouteAds,
} from './routes';
import PageNotFound from '~/commons/components/PageNotFound.jsx';

const Admin = () => (
  <div className="container-fluid h-100">
    <div className="row h-100">
      <Router>
        <Nav />
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/admin" exact>
                <Redirect to="/admin/users/admins" />
              </Route>
              <Route path="/admin/users">
                <RouteUsers />
              </Route>
              <Route path="/admin/players">
                <RoutePlayers />
              </Route>
              <Route path="/admin/pics">
                <RoutePics />
              </Route>
              <Route path="/admin/horses">
                <RouteHorses />
              </Route>
              <Route path="/admin/banners">
                <RouteBanners />
              </Route>
              <Route path="/admin/locations">
                <RouteLocations />
              </Route>
              <Route path="/admin/races">
                <RouteRaces />
              </Route>
              <Route path="/admin/badges">
                <RouteBadges />
              </Route>
              <Route path="/admin/trades">
                <RouteTrades />
              </Route>
              <Route path="/admin/breeds">
                <RouteBreeds />
              </Route>
              <Route path="/admin/shares">
                <RouteShares />
              </Route>
              <Route path="/admin/config">
                <RouteConfigs />
              </Route>
              <Route path="/admin/trainings">
                <RouteTrainings />
              </Route>
              <Route path="/admin/items">
                <RouteItems />
              </Route>
              <Route path="/admin/ads">
                <RouteAds />
              </Route>
              <Route path="/admin/blockchain-transactions">
                <RouteBlockchainTransactions />
              </Route>
              <Route path="/admin/paymentRecords">
                <RoutePaymentRecords />
              </Route>
              <Route path="/admin/operations">
                <RouteOperations />
              </Route>
              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
);

export default Admin;
